import type { PostStatus } from '@news-cms/shared';
import { Badge } from '@/components/ui/badge';

const LABEL: Record<PostStatus, string> = {
  draft: 'ฉบับร่าง',
  pending_review: 'รออนุมัติ',
  scheduled: 'ตั้งเวลา',
  published: 'เผยแพร่',
  archived: 'เก็บถาวร',
};

const VARIANT: Record<PostStatus, 'muted' | 'warning' | 'info' | 'success' | 'secondary'> = {
  draft: 'muted',
  pending_review: 'warning',
  scheduled: 'info',
  published: 'success',
  archived: 'secondary',
};

export function PostStatusBadge({ status }: { status: PostStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
